import React, {forwardRef, RefObject} from 'react'
import {Box, Flex, Text} from '../'
import {PolymorphicComponentProps} from './Box'
import {checkboxRecipe, CheckBoxVariants} from './checkbox.css'
import { Markdown } from '../../components/cms/Markdown'

type StyleProps = object & CheckBoxVariants

type UVariant<T = StyleProps> = T extends CheckBoxVariants ? Omit<T, 'variant'> : never

type CheckBoxOwnProps = UVariant & {
  disabled?: boolean
  variant?: StyleProps['variant']
  label: React.ReactNode
  hasError: boolean
  showAsterisk?: boolean
}

export type CheckboxProps = PolymorphicComponentProps<'input', CheckBoxOwnProps>

export const Checkbox = forwardRef(
  ({variant, size, label, hasError, id, name, showAsterisk, ...props}: CheckboxProps, ref) => {
    const checkboxClassName = checkboxRecipe({variant, size, error: hasError})

    const adjustedLabel = typeof label === 'string' && showAsterisk
      ? `${label} <span style="color: #D32F2F;">*</span>`
      : label

    return (
      <Flex as="label" align="center" gap="8px">
        <Box
          name={name}
          as="input"
          type="checkbox"
          flexShrink="0"
          alignSelf="flex-start"
          className={checkboxClassName}
          id={id}
          {...props}
          ref={ref as RefObject<HTMLInputElement>}
        />
        {typeof adjustedLabel === 'string' ? (
          <Text as="label" title={typeof label === 'string' ? label : undefined} variant="text4" lineHeight="short" marginTop="2px" htmlFor={id}>
            <Markdown markdown={adjustedLabel}/>
          </Text>
        ) : (
          adjustedLabel
        )}
      </Flex>
    )
  },
)
